import { action } from 'typesafe-actions';
import {
  BOOKIES_FAILURE,
  BOOKIES_REQUEST,
  BOOKIES_SUCCESS,
} from '../../constants/bookies';

export const bookiesRequestAction = () => action(BOOKIES_REQUEST);
export const bookiesSuccessAction = (data: any) =>
  action(BOOKIES_SUCCESS, data);
export const bookiesFailureAction = (e: any) => action(BOOKIES_FAILURE, e);

export const bookiesActions = {
  bookiesRequestAction,
  bookiesSuccessAction,
  bookiesFailureAction,
};
